export const project = 'taggingng'; // need this for when we dynamically import utils

const shortFranchiseCode = {
	buick: 'bu',
	cadillac: 'ca',
	chevrolet: 'ch',
	gmc: 'gm'
};

export const getShortFranchises = () =>
	window?.DDC?.dataLayer?.site?.franchises
		?.map((franchise) => shortFranchiseCode[franchise.toLowerCase()])
		.join('|');

export const getDealerBac = () => {
	// get the dealerCode if found or undefined
	const foundObject = window?.DDC?.dataLayer?.dealership?.dealerCode?.find(
		({ gm, gmcabac } = {}) => gm || gmcabac
	);

	return (
		foundObject?.gm ||
		foundObject?.gmcabac ||
		'Account {} not configured with a BAC dealer code'
	);
};
